import missionaryImg from '../Assets/cube.jpeg';
import cowgirlImg from '../Assets/cube.jpeg';
import doggyImg from '../Assets/cube.jpeg';
import spooningImg from '../Assets/cube.jpeg';
import standingImg from '../Assets/cube.jpeg';
import edgeOfBedImg from '../Assets/cube.jpeg';
import sixtyNineImg from '../Assets/cube.jpeg';
import lotusImg from '../Assets/cube.jpeg';
import eagleSpreadImg from '../Assets/cube.jpeg';
import reverseCowgirlImg from '../Assets/cube.jpeg';


export const sexualHealthData = {
  overview: {
    introduction: "Sexual health is a fundamental aspect of overall well-being that encompasses physical, emotional, mental, and social aspects of sexuality. It involves having positive and respectful approaches to sexuality and sexual relationships.",
    importance: [
      "Physical health and disease prevention",
      "Emotional well-being and self-esteem",
      "Healthy relationships and communication",
      "Reproductive health and family planning",
      "Mental health and stress management",
      "Personal autonomy and informed choices"
    ],
    myths: [
      {
        myth: "Sexual health education promotes promiscuity",
        fact: "Comprehensive sexual health education actually promotes responsible behavior and informed decision-making"
      },
      {
        myth: "Only sexually active people need sexual health information",
        fact: "Sexual health education is important for everyone regardless of sexual activity status"
      },
      {
        myth: "Talking about sex is inappropriate",
        fact: "Open, honest communication about sexual health is essential for well-being and safety"
      }
    ]
  },

  anatomy: {
    maleAnatomy: {
      external: [
        {
          part: "Penis",
          function: "Sexual intercourse, urination, contains urethra and erectile tissue",
          health: "Keep clean, watch for unusual discharge or sores"
        },
        {
          part: "Scrotum",
          function: "Houses testicles, regulates temperature for sperm production",
          health: "Regular self-examination for lumps or changes"
        },
        {
          part: "Testicles",
          function: "Produce sperm and testosterone",
          health: "Monthly self-exams, watch for swelling or pain"
        }
      ],
      internal: [
        {
          part: "Prostate Gland",
          function: "Produces fluid that nourishes and protects sperm",
          health: "Regular check-ups after age 40-50"
        },
        {
          part: "Seminal Vesicles",
          function: "Produce fluid that makes up part of semen",
          health: "Maintain through healthy lifestyle"
        }
      ]
    },
    femaleAnatomy: {
      external: [
        {
          part: "Vulva",
          function: "External female genitalia including labia, clitoris, and vaginal opening",
          health: "Gentle cleaning with water, avoid harsh soaps"
        },
        {
          part: "Clitoris",
          function: "Contains thousands of nerve endings, important for sexual pleasure",
          health: "Normal variation in size and appearance"
        }
      ],
      internal: [
        {
          part: "Vagina",
          function: "Birth canal, menstrual flow exit, sexual intercourse",
          health: "Self-cleaning organ, maintain healthy pH balance"
        },
        {
          part: "Uterus",
          function: "Houses developing fetus during pregnancy, sheds lining during menstruation",
          health: "Regular gynecological check-ups"
        },
        {
          part: "Ovaries",
          function: "Produce eggs and hormones (estrogen and progesterone)",
          health: "Regular check-ups, aware of family history"
        }
      ]
    }
  },

  contraception: {
    methods: [
      {
        name: "Condoms (Male/Female)",
        effectiveness: "85-98%",
        type: "Barrier",
        pros: ["STI protection", "No hormones", "Available over-the-counter"],
        cons: ["Must use correctly every time", "Can break or slip"],
        suitability: "Everyone, especially those wanting STI protection"
      },
      {
        name: "Birth Control Pills",
        effectiveness: "91-99%",
        type: "Hormonal",
        pros: ["Highly effective", "May reduce acne", "Lighter periods"],
        cons: ["Daily use required", "Possible side effects", "No STI protection"],
        suitability: "Those who can remember daily medication"
      },
      {
        name: "IUD (Intrauterine Device)",
        effectiveness: "99%",
        type: "Long-acting",
        pros: ["Long-lasting", "Highly effective", "Low maintenance"],
        cons: ["Insertion procedure", "Possible side effects", "No STI protection"],
        suitability: "Those wanting long-term contraception"
      },
      {
        name: "Implant",
        effectiveness: "99%",
        type: "Hormonal",
        pros: ["3-year protection", "Highly effective", "Reversible"],
        cons: ["Minor surgery for insertion/removal", "Possible irregular bleeding"],
        suitability: "Those wanting long-term hormonal contraception"
      },
      {
        name: "Depo-Provera Shot",
        effectiveness: "94-99%",
        type: "Hormonal",
        pros: ["Quarterly injections", "May stop periods", "Private"],
        cons: ["Regular appointments needed", "Delayed return to fertility"],
        suitability: "Those who prefer quarterly visits"
      }
    ],
emergencyContraception: [

  {
    name: "Postinor-2 (Levonorgestrel)",
    timeframe: "Up to 72 hours after unprotected sex",
    effectiveness: "88% if taken within 72 hours",
    availability: "Widely available in pharmacies across Nigeria"
  },
  {
    name: "Pregnon (Levonorgestrel)",
    timeframe: "Up to 72 hours after unprotected sex",
    effectiveness: "85% if taken within 72 hours",
    availability: "Commonly available in Nigerian pharmacies"
  },

]

  },

  sti: {
    overview: "Sexually transmitted infections (STIs) are infections that are passed from one person to another through sexual contact.",
    commonSTIs: [
      {
        name: "Chlamydia",
        type: "Bacterial",
        symptoms: ["Often no symptoms", "Unusual discharge", "Burning during urination", "Pelvic pain"],
        treatment: "Antibiotics",
        complications: "Can cause infertility if untreated",
        prevention: "Condoms, regular testing"
      },
      {
        name: "Gonorrhea",
        type: "Bacterial",
        symptoms: ["Painful urination", "Unusual discharge", "Pelvic pain", "Often asymptomatic"],
        treatment: "Antibiotics",
        complications: "Can cause infertility and joint problems",
        prevention: "Condoms, regular testing"
      },
      {
        name: "Syphilis",
        type: "Bacterial",
        symptoms: ["Painless sores", "Rash", "Flu-like symptoms", "Can progress to serious complications"],
        treatment: "Antibiotics (penicillin)",
        complications: "Can affect heart, brain, and other organs",
        prevention: "Condoms, regular testing"
      },
      {
        name: "Herpes (HSV-1/HSV-2)",
        type: "Viral",
        symptoms: ["Painful blisters or sores", "Flu-like symptoms", "Often no symptoms"],
        treatment: "Antiviral medications (manage symptoms)",
        complications: "Recurrent outbreaks, transmission to newborns",
        prevention: "Condoms (reduce risk), avoid contact during outbreaks"
      },
      {
        name: "HIV",
        type: "Viral",
        symptoms: ["Flu-like symptoms initially", "Then often no symptoms for years"],
        treatment: "Antiretroviral therapy (ART)",
        complications: "Can progress to AIDS if untreated",
        prevention: "Condoms, PrEP, regular testing"
      },
      {
        name: "HPV (Human Papillomavirus)",
        type: "Viral",
        symptoms: ["Often no symptoms", "Genital warts", "Abnormal Pap smears"],
        treatment: "No cure, symptoms can be treated",
        complications: "Can cause cervical and other cancers",
        prevention: "HPV vaccine, condoms, regular screening"
      }
    ],
    testing: {
      frequency: "At least annually for sexually active individuals, more frequent if multiple partners",
      types: ["Blood tests", "Urine tests", "Swab tests", "Physical examination"],
      importance: "Many STIs have no symptoms but can cause serious health problems if untreated"
    }
  },

  sexualWellness: {
    communication: [
      {
        topic: "Consent",
        importance: "Foundation of all healthy sexual interactions",
        principles: [
          "Must be freely given without coercion",
          "Can be withdrawn at any time",
          "Must be informed and enthusiastic",
          "Cannot be given when intoxicated or unconscious",
          "Ongoing - not just once"
        ]
      },
      {
        topic: "Boundaries",
        importance: "Protecting personal comfort and safety",
        tips: [
          "Know your own boundaries",
          "Communicate them clearly",
          "Respect others' boundaries",
          "Boundaries can change",
          "It's okay to say no"
        ]
      }
    ],
    sexualResponse: {
      phases: [
        "Desire/Interest",
        "Arousal/Excitement", 
        "Plateau",
        "Orgasm (not always present)",
        "Resolution"
      ],
      variations: "Sexual response varies greatly between individuals and can be affected by physical, emotional, and psychological factors"
    },
    commonConcerns: [
      {
        concern: "Low sexual desire",
        causes: ["Stress", "Hormonal changes", "Relationship issues", "Medical conditions"],
        solutions: ["Stress management", "Communication", "Medical consultation", "Therapy"]
      },
      {
        concern: "Pain during sex",
        causes: ["Insufficient lubrication", "Infections", "Medical conditions", "Psychological factors"],
        solutions: ["Use lubrication", "Medical evaluation", "Gradual approach", "Professional help"]
      }
    ]
  },

  reproductiveHealth: {
    menstrualHealth: {
      cycle: "Average 28 days, normal range 21-35 days",
      phases: [
        "Menstrual phase (days 1-5)",
        "Follicular phase (days 1-13)",
        "Ovulation (around day 14)",
        "Luteal phase (days 15-28)"
      ],
      products: [
        {
          type: "Pads",
          pros: ["Easy to use", "Good for heavy flow"],
          cons: ["Can feel bulky", "Not eco-friendly"]
        },
        {
          type: "Tampons",
          pros: ["Discreet", "Good for active lifestyles"],
          cons: ["TSS risk if not changed regularly", "Can be difficult to insert"]
        },
        {
          type: "Menstrual cups",
          pros: ["Eco-friendly", "Cost-effective long-term", "Can wear up to 12 hours"],
          cons: ["Learning curve", "Initial cost"]
        }
      ]
    },
    fertility: {
      factors: [
        "Age (fertility declines with age)",
        "Overall health and nutrition",
        "Weight (too high or too low can affect fertility)",
        "Smoking and alcohol use",
        "Stress levels",
        "Medical conditions"
      ],
      awareness: "Understanding your menstrual cycle can help with both conception and contraception"
    }
  },

  sexualIntimacy: {
    overview: "Sexual intimacy involves physical, emotional, and psychological connection between partners. It's about pleasure, communication, and mutual satisfaction.",
    preparation: {
      mentalPreparation: [
        "Open communication with partner about desires and boundaries",
        "Relaxation techniques to reduce anxiety",
        "Understanding your own body and what feels good",
        "Setting the mood and creating comfortable environment",
        "Ensuring privacy and adequate time"
      ],
      physicalPreparation: [
        "Good personal hygiene",
        "Trimming nails to avoid discomfort",
        "Using the bathroom beforehand",
        "Having necessary supplies (condoms, lubricant)",
        "Comfortable temperature and lighting"
      ]
    },
    foreplay: {
      importance: "Foreplay increases arousal, improves lubrication, and enhances overall sexual experience",
      techniques: [
        {
          category: "Kissing",
          description: "Start gentle, vary pressure and speed, explore different areas",
          tips: ["Use lips, tongue variation", "Kiss neck, ears, other erogenous zones", "Pay attention to partner's response"]
        },
        {
          category: "Touch and Massage",
          description: "Explore your partner's body with hands",
          tips: ["Start with gentle caressing", "Vary pressure and speed", "Focus on erogenous zones", "Use massage oils if desired"]
        },
        {
          category: "Oral Stimulation",
          description: "Using mouth and tongue for pleasure",
          tips: ["Start slowly and gently", "Pay attention to partner's reactions", "Vary techniques", "Communication is key"]
        }
      ]
    },
    positions: {
      beginner: [
        {
          name: "Missionary",
          description: "Classic face-to-face position with receiving partner on bottom",
          benefits: ["Easy eye contact and kissing", "Good for beginners", "Allows for intimate communication"],
          tips: ["Use pillows for comfort and angle adjustment", "Receiving partner can wrap legs around partner", "Allows for clitoral stimulation"],
          image: missionaryImg,
          difficulty: "⭐ Beginner",
          pleasureLevel: "🔥🔥🔥 High",
          entryTechnique: "Slow & gentle penetration, let her guide the pace",
          bestFor: "Intimacy, eye contact, G-spot stimulation"
        },
        {
          name: "Spooning",
          description: "Side-by-side position with penetrating partner behind",
          benefits: ["Comfortable and intimate", "Good for lazy mornings", "Less physically demanding"],
          tips: ["Receiving partner can control depth", "Good for pregnant partners", "Allows for touching and caressing"],
          image: spooningImg,
          difficulty: "⭐ Beginner",
          pleasureLevel: "🔥🔥🔥 High",
          entryTechnique: "Gentle entry from behind, she lifts top leg slightly",
          bestFor: "Lazy sex, pregnancy, intimate connection"
        },
        {
          name: "Woman on Top",
          description: "Receiving partner straddles and controls movement",
          benefits: ["Receiving partner controls pace and depth", "Good for clitoral stimulation", "Less work for penetrating partner"],
          tips: ["Start slowly", "Lean forward or backward for different sensations", "Use hands for additional stimulation"],
          image: cowgirlImg,
          difficulty: "⭐⭐ Easy",
          pleasureLevel: "🔥🔥🔥🔥 Very High",
          entryTechnique: "She slowly lowers herself down, controls depth",
          bestFor: "Her orgasm, clit stimulation, she's in control"
        }
      ],
      intermediate: [
        {
          name: "Doggy Style",
          description: "Penetrating partner behind, receiving partner on hands and knees",
          benefits: ["Deep penetration", "G-spot/P-spot stimulation", "Different angle of entry"],
          tips: ["Use pillows for comfort", "Receiving partner can lower to forearms", "Allow for manual stimulation"],
          image: doggyImg,
          difficulty: "⭐⭐ Easy",
          pleasureLevel: "🔥🔥🔥🔥🔥 Intense",
          entryTechnique: "Enter slowly from behind, check angle isn't too steep",
          bestFor: "Deep penetration, G-spot hitting, primal feeling"
        },
        {
          name: "Standing",
          description: "Both partners standing during intercourse",
          benefits: ["Can be spontaneous", "Different sensation", "Good for shower/against wall"],
          tips: ["Height differences may require adjustment", "Use wall or furniture for support", "May require strength"],
          image: standingImg,
          difficulty: "⭐⭐⭐ Moderate",
          pleasureLevel: "🔥🔥🔥🔥 Very High",
          entryTechnique: "Support her weight, she lifts one leg or wraps around you",
          bestFor: "Spontaneous sex, shower fun, quick sessions"
        },
        {
          name: "Edge of Bed",
          description: "Receiving partner on edge of bed, penetrating partner standing",
          benefits: ["Good angle for G-spot stimulation", "Easy access for manual stimulation", "Comfortable for both partners"],
          tips: ["Adjust bed height with pillows", "Receiving partner can lie back or sit up", "Good for face-to-face contact"],
          image: edgeOfBedImg,
          difficulty: "⭐⭐ Easy",
          pleasureLevel: "🔥🔥🔥🔥 Very High",
          entryTechnique: "Perfect height alignment, smooth entry",
          bestFor: "G-spot stimulation, deep penetration, control"
        },
        {
          name: "69 Position",
          description: "Mutual oral pleasure",
          benefits: ["Simultaneous pleasure", "Intimate connection", "Great for foreplay"],
          tips: ["Take turns being active", "Try side-by-side position", "Communication is key"],
          image: sixtyNineImg,
          difficulty: "⭐⭐⭐ Moderate",
          pleasureLevel: "🔥🔥🔥🔥 Very High",
          entryTechnique: "Position carefully, focus on giving not receiving",
          bestFor: "Mutual pleasure, oral skills, foreplay"
        },
        {
          name: "Lotus Position",
          description: "Sitting face-to-face with legs wrapped around each other",
          benefits: ["Very intimate", "Eye contact", "Tantric connection"],
          tips: ["Start slow", "Focus on connection", "Good for experienced couples"],
          image: lotusImg,
          difficulty: "⭐⭐⭐⭐ Advanced",
          pleasureLevel: "🔥🔥🔥🔥🔥 Intense",
          entryTechnique: "She sits on you slowly, both cross-legged",
          bestFor: "Tantric sex, deep connection, slow lovemaking"
        },
        {
          name: "Eagle Spread",
          description: "Receiving partner on back with legs spread wide",
          benefits: ["Deep penetration", "Full access", "Visual pleasure"],
          tips: ["Support her legs", "Use pillows for comfort", "Great for manual stimulation"],
          image: eagleSpreadImg,
          difficulty: "⭐⭐ Easy",
          pleasureLevel: "🔥🔥🔥🔥 Very High",
          entryTechnique: "She spreads legs wide, you enter between them",
          bestFor: "Deep penetration, clit access, visual pleasure"
        },
        {
          name: "Reverse Cowgirl",
          description: "Receiving partner on top facing away",
          benefits: ["Visual pleasure", "Different angle", "She controls pace"],
          tips: ["Let her find her angle", "Support if needed", "Great view"],
          image: reverseCowgirlImg,
          difficulty: "⭐⭐⭐ Moderate",
          pleasureLevel: "🔥🔥🔥🔥 Very High",
          entryTechnique: "She faces away and slowly sits down on you",
          bestFor: "Visual pleasure, her control, different angle"
        }
      ]
    },
    techniques: {
      communication: [
        "Ask what feels good",
        "Give positive feedback",
        "Be honest about your needs",
        "Use non-verbal cues",
        "Check in regularly during intimacy"
      ],
      pleasure: [
        "Focus on the journey, not just the destination",
        "Pay attention to all erogenous zones",
        "Vary speed, pressure, and rhythm",
        "Use your hands, mouth, and body",
        "Be present and mindful"
      ]
    }
  },  sexualPleasure: {
    overview: "Sexual pleasure is a natural and healthy part of human sexuality that can be experienced alone or with partners.",
    
    orgasmGuide: [
      {
        name: "🔥 Quick Tips",
        description: "Master these basics first!",
        techniques: [
          "👄 Foreplay = 15+ minutes minimum",
          "💦 Use lube - lots of it!",
          "🗣️ Talk during sex - guide your partner",
          "😌 Relax your mind = better orgasms"
        ]
      },
      {
        name: "👆 Clitoral Magic",
        description: "8,000+ nerve endings - treat with care!",
        techniques: [
          "🔄 Circle around it, not directly on it",
          "⚡ Light touch → gradually increase pressure",
          "✋ Use 2 fingers, not just 1",
          "💧 Spit or lube = your best friend"
        ]
      },
      {
        name: "🎯 G-Spot Hacks",
        description: "2-3 inches inside, front wall - feels ridged",
        techniques: [
          "👆 'Come here' finger motion",
          "💪 Firm pressure, not gentle",
          "🤝 Use both hands - clit + G-spot",
          "📐 Positions: Doggy, girl-on-top work best"
        ]
      },
      {
        name: "🍆 Hand Job",
        description: "Focus on these super sensitive spots:",
        techniques: [
          "👑 Head = most sensitive part",
          "🔥 Frenulum (under head) = jackpot",
          "👐 Use both hands, vary grip",
          "🌊 Change speed every 30 seconds"
        ]
      },
      {
        name: "🎯 Prostate Power",
        description: "Male G-spot = intense full-body orgasms",
        techniques: [
          "🍑 Start with butt massage first",
          "🛢️ TONS of lube - don't be cheap",
          "👆 2-3 inches in, curve toward belly",
          "⚡ Combine with regular stroking"
        ]
      },
      {
        name: "🔄 Multiple O's",
        description: "Keep the party going!",
        techniques: [
          "🚫 DON'T stop after first orgasm",
          "😮‍💨 Breathe deep, stay relaxed",
          "👐 Lighter touch right after",
          "⏰ Wait 30 seconds, then build again"
        ]
      }
    ],

    pleasureTechniques: [
      {
        name: "🔥 Foreplay Hacks",
        description: "Get her wet before you start!",
        techniques: [
          "👐 Start with massage, not touching privates",
          "💋 Kiss everywhere EXCEPT her lips first",
          "👂 Whisper what you're gonna do to her",
          "⏰ Minimum 15 minutes - no rushing!"
        ]
      },
      {
        name: "👅 Oral Sex",
        description: "Make her legs shake!",
        techniques: [
          "🔄 Circle around clit, not directly on it",
          "👅 Flat tongue = broad strokes, pointed = precision",
          "💦 Start gentle, get harder as she gets wetter",
          "👐 Use fingers inside while licking",
          "🗣️ Ask 'Does this feel good?' and listen!"
        ]
      },
      {
        name: "🍆 Oral Sex",
        description: "Make him melt!",
        techniques: [
          "👅 Lick the head like an ice cream cone",
          "🔥 Focus on frenulum (under the head)",
          "👐 Use hands + mouth together",
          "💦 Spit is lube - use lots",
          "👀 Eye contact = instant turn on"
        ]
      },
      {
        name: "👐 Fingering Techniques",
        description: "Make her cum with just your hands!",
        techniques: [
          "✂️ Cut your nails SHORT",
          "💧 Lube first, always",
          "👆 G-spot = 'come here' motion",
          "🔄 Circle on clit while fingering",
          "💪 Firm pressure, not gentle touches"
        ]
      },
      {
        name: "🔥 Drive Her Wild",
        description: "Hot spots that work every time!",
        techniques: [
          "👂 Neck + ear = instant wetness",
          "🦵 Inner thighs = tease before the main event",
          "🍑 Nipples = pinch, don't just touch",
          "💋 Back of neck = kiss while from behind",
          "🦶 Feet massage = surprisingly sexy AF"
        ]
      },
      {
        name: "💦 Squirting 101",
        description: "How to make her squirt!",
        techniques: [
          "🎯 G-spot + clit stimulation together",
          "💪 Hard, fast pressure on G-spot",
          "💦 She needs to pee? That's the feeling!",
          "🛏️ Put towels down first",
          "🗣️ Tell her to let go, don't hold back"
        ]
      }
    ],

    erogenousZones: {
      primary: [
        {
          zone: "Genitals",
          description: "Most sensitive sexual organs",
          techniques: ["Vary touch, pressure, and speed", "Use lubrication when needed", "Pay attention to responses"]
        }
      ],
      secondary: [
        {
          zone: "Neck and Ears",
          description: "Highly sensitive to gentle touch and breath",
          techniques: ["Light kissing", "Gentle nibbling", "Warm breath", "Soft whispers"]
        },
        {
          zone: "Inner Thighs",
          description: "Sensitive area close to genitals",
          techniques: ["Light caressing", "Gentle massage", "Kissing", "Teasing touch"]
        },
        {
          zone: "Nipples",
          description: "Sensitive to touch and temperature",
          techniques: ["Gentle pinching", "Circular motions", "Temperature play", "Varying pressure"]
        },
        {
          zone: "Lower Back",
          description: "Can enhance arousal and relaxation",
          techniques: ["Massage", "Light scratching", "Firm touch", "Oil massage"]
        }
      ]
    },
    masturbation: {
      overview: "Self-pleasure is normal, healthy, and can improve sexual satisfaction",
      benefits: [
        "Helps you understand your body",
        "Reduces stress and tension",
        "Can improve sleep",
        "May help with menstrual cramps",
        "Enhances sexual experiences with partners"
      ],
      techniques: {
        forPeopleWithVulvas: [
          "Clitoral stimulation with fingers or toys",
          "Internal stimulation (G-spot)",
          "Combination of both",
          "Use of lubricant for comfort",
          "Experiment with different pressures and speeds"
        ],
        forPeopleWithPenises: [
          "Vary grip and speed",
          "Focus on different areas (head, shaft, base)",
          "Use lubrication",
          "Try different techniques and rhythms",
          "Explore other sensitive areas"
        ]
      },
      myths: [
        {
          myth: "Masturbation is harmful or unhealthy",
          fact: "Masturbation is completely normal and healthy when practiced safely"
        },
        {
          myth: "Too much masturbation causes problems",
          fact: "Masturbation only becomes a problem if it interferes with daily life or relationships"
        }
      ]
    },
    orgasm: {
      definition: "A climax of sexual excitement characterized by intense pleasure and muscle contractions",
      types: {
        clitoral: "Stimulation of the clitoris, most common type for people with vulvas",
        vaginal: "Stimulation through the vagina, often involves G-spot",
        blended: "Combination of clitoral and vaginal stimulation",
        multiple: "Experiencing more than one orgasm in a session",
        penile: "Typical orgasm through penile stimulation"
      },
      myths: [
        {
          myth: "Everyone should orgasm during sex",
          fact: "Orgasm isn't necessary for satisfying sex; pleasure and intimacy are equally important"
        },
        {
          myth: "People with vulvas should orgasm from penetration alone",
          fact: "Most people with vulvas need clitoral stimulation to orgasm"
        }
      ],
      tips: [
        "Focus on pleasure, not pressure to orgasm",
        "Communicate with your partner",
        "Relax and be present",
        "Explore different types of stimulation",
        "Don't fake it - honest communication is better"
      ]
    }
  },

  sexualDysfunction: {
    overview: "Sexual dysfunction is common and treatable. It can affect desire, arousal, orgasm, or cause pain.",
    commonIssues: [
      {
        condition: "Erectile Dysfunction (ED)",
        description: "Difficulty getting or maintaining an erection",
        causes: ["Physical health issues", "Psychological factors", "Medications", "Lifestyle factors"],
        treatments: ["Medical evaluation", "Medications", "Lifestyle changes", "Counseling", "Vacuum devices"],
        whenToSeekHelp: "If it happens regularly and affects quality of life"
      },
      {
        condition: "Premature Ejaculation",
        description: "Ejaculating sooner than desired during sexual activity",
        causes: ["Psychological factors", "Sensitivity", "Relationship issues", "Stress"],
        treatments: ["Behavioral techniques", "Topical anesthetics", "Medications", "Counseling"],
        whenToSeekHelp: "If it causes distress or relationship problems"
      },
      {
        condition: "Low Sexual Desire",
        description: "Decreased interest in sexual activity",
        causes: ["Hormonal changes", "Stress", "Relationship issues", "Medical conditions", "Medications"],
        treatments: ["Address underlying causes", "Counseling", "Hormone therapy", "Lifestyle changes"],
        whenToSeekHelp: "If it causes personal distress or relationship problems"
      },
      {
        condition: "Painful Intercourse (Dyspareunia)",
        description: "Pain during sexual intercourse",
        causes: ["Insufficient lubrication", "Infections", "Medical conditions", "Psychological factors"],
        treatments: ["Medical evaluation", "Lubrication", "Treatment of underlying conditions", "Gradual exposure therapy"],
        whenToSeekHelp: "Any pain during sex should be evaluated by a healthcare provider"
      },
      {
        condition: "Vaginismus",
        description: "Involuntary muscle spasms that make penetration difficult or impossible",
        causes: ["Physical trauma", "Psychological factors", "Medical conditions", "Past experiences"],
        treatments: ["Pelvic floor therapy", "Gradual dilation therapy", "Counseling", "Medical treatment"],
        whenToSeekHelp: "If penetration is consistently difficult or impossible"
      }
    ],
    generalTreatment: [
      "Open communication with partners",
      "Medical evaluation to rule out physical causes",
      "Counseling or sex therapy",
      "Lifestyle modifications (exercise, stress reduction)",
      "Education about sexual response and techniques"
    ]
  },

  sexualSafety: {
    overview: "Sexual safety involves protecting physical and emotional well-being during sexual activities",
    allPhysicalSafety: [
      {
        topic: "Safe Sex Practices",
        details: [
          "Use condoms or dental dams for all sexual activities",
          "Get tested regularly for STIs",
          "Discuss sexual history with partners",
          "Use clean sex toys and don't share them",
          "Be aware of allergies (latex, lubricants)",
          "Check expiration dates on condoms",
          "Store condoms properly - not in wallets or hot cars",
          "Use water-based or silicone-based lubricants with latex condoms"
        ],
        icon: "🔒",
        priority: "high"
      },
      {
        topic: "Preparation and Hygiene",
        details: [
          "Wash hands before sexual activity",
          "Trim fingernails to prevent injury",
          "Use plenty of lubrication to prevent tearing",
          "Go slowly, especially with anal play",
          "Never go from anal to vaginal contact without cleaning",
          "Shower or clean genital areas before intimacy",
          "Use separate towels for different body parts",
          "Clean sex toys before and after each use"
        ],
        icon: "🚿",
        priority: "high"
      },
      {
        topic: " Health Monitoring",
        details: [
          "Regular STI testing every 3-6 months if sexually active",
          "Annual gynecological exams for people with vulvas",
          "Prostate exams for men over 40",
          "Self-examine genitals monthly for changes",
          "Track menstrual cycles and irregularities",
          "Monitor for unusual discharge, odor, or pain",
          "Get HPV vaccination if eligible",
          "Discuss sexual health with healthcare providers"
        ],
        icon: "🩺",
        priority: "medium"
      },
      {
        topic: "Contraception Safety",
        details: [
          "Use dual protection - hormonal + barrier methods",
          "Take birth control pills at the same time daily",
          "Know emergency contraception options and timing",
          "Understand failure rates of different methods",
          "Have backup contraception available",
          "Replace condoms if package is damaged",
          "Learn proper condom application techniques",
          "Discuss contraception with all partners"
        ],
        icon: "💊",
        priority: "high"
      },
      {
        topic: "Substance Safety",
        details: [
          "Avoid sexual activity when heavily intoxicated",
          "Never use drugs or alcohol to coerce someone",
          "Be aware that substances can impair judgment",
          "Watch your drinks at parties or social events",
          "Don't accept drinks from strangers",
          "Have a sober friend you can call",
          "Know that consent cannot be given when intoxicated",
          "Be extra cautious with new partners while drinking"
        ],
        icon: "🚫",
        priority: "high"
      },
      {
        topic: "Environment Safety",
        details: [
          "Choose safe, comfortable locations for intimacy",
          "Ensure privacy and won't be interrupted",
          "Have good lighting to see what you're doing",
          "Keep emergency contacts easily accessible",
          "Trust your instincts about unsafe situations",
          "Let someone know your whereabouts with new partners",
          "Meet new partners in public places first",
          "Have your own transportation or ride home"
        ],
        icon: "🏡",
        priority: "medium"
      },
      {
        topic: "Injury Prevention",
        details: [
          "Start slowly with new activities or positions",
          "Use adequate lubrication to prevent tearing",
          "Stop immediately if there's pain or discomfort",
          "Learn proper techniques for anal play",
          "Be gentle with sensitive areas",
          "Don't force anything that doesn't feel right",
          "Have first aid supplies nearby for minor injuries",
          "Know when to seek medical attention"
        ],
        icon: "⚠️",
        priority: "medium"
      },
      {
        topic: "Sex Toy Safety",
        details: [
          "Buy toys from reputable manufacturers only",
          "Use body-safe materials (silicone, glass, medical-grade)",
          "Clean toys before and after every use",
          "Don't share toys without proper cleaning",
          "Use condoms on toys for easy cleanup",
          "Store toys in clean, dry places",
          "Replace toys when they show wear or damage",
          "Use appropriate lubricants with different materials"
        ],
        icon: "🧸",
        priority: "medium"
      }
    ],
    allEmotionalSafety: [
      {
        topic: "Consent Communication",
        details: [
          "Establish clear consent before any sexual activity",
          "Respect boundaries and stop when asked",
          "Create a comfortable, pressure-free environment",
          "Check in with your partner during activities",
          "Practice aftercare - cuddling, talking, or whatever feels good"
        ],
        tips: [
          "Use clear 'yes' and 'no' language",
          "Ask specific questions about what feels good",
          "Create safe words for different situations",
          "Regularly discuss boundaries and limits",
          "Remember consent can be withdrawn anytime"
        ]
      },
      {
        topic: "Relationship Boundaries",
        details: [
          "Discuss expectations before becoming intimate",
          "Respect each other's relationship status",
          "Be honest about other sexual partners",
          "Don't pressure anyone into activities they're unsure about",
          "Maintain confidentiality about intimate details"
        ],
        tips: [
          "Have the 'what are we' conversation early",
          "Discuss STI testing and sharing results",
          "Talk about emotional attachment expectations",
          "Respect privacy about past relationships",
          "Be clear about your own needs and limits"
        ]
      },
      {
        topic: "Mental Health Considerations",
        details: [
          "Check in on emotional well-being before and after",
          "Be aware of trauma triggers and responses",
          "Create a supportive environment for vulnerability",
          "Practice patience with sexual difficulties",
          "Seek professional help when needed"
        ],
        tips: [
          "Learn about trauma-informed approaches to sex",
          "Have resources for mental health support ready",
          "Practice active listening without judgment",
          "Normalize therapy and counseling",
          "Take breaks when emotions become overwhelming"
        ]
      },
      {
        topic: "Handling Rejection",
        details: [
          "Accept 'no' gracefully without argument",
          "Don't take rejection personally",
          "Maintain respect even after being turned down",
          "Give space when someone needs it",
          "Focus on enthusiastic partners instead"
        ],
        tips: [
          "Remember everyone has the right to say no",
          "Thank partners for being honest about their boundaries",
          "Don't try to negotiate or convince after a no",
          "Process rejection privately, not with the person",
          "Learn from experiences without becoming bitter"
        ]
      },
      {
        topic: "Managing Expectations",
        details: [
          "Communicate fantasies vs. realistic expectations",
          "Don't base expectations solely on media portrayals",
          "Be patient with learning curves and mistakes",
          "Focus on connection over performance",
          "Celebrate small victories and improvements"
        ],
        tips: [
          "Discuss what 'good sex' means to each person",
          "Set realistic goals for sexual experiences",
          "Remember that porn isn't realistic sex education",
          "Focus on pleasure rather than specific outcomes",
          "Give positive feedback more than constructive criticism"
        ]
      }
    ],
    allRiskReduction: [
      {
        category: "Partner Management",
        strategies: [
          "Limit number of sexual partners",
          "Choose partners who are also committed to safe sex",
          "Have honest conversations about sexual history",
          "Get tested together before unprotected sex",
          "Consider mutual monogamy for risk reduction"
        ],
        tips: [
          "Quality relationships over quantity of partners",
          "Regular STI testing for all partners",
          "Open communication about other relationships",
          "Respect partners' choices about protection"
        ]
      },
      {
        category: "High-Risk Situations",
        strategies: [
          "Avoid sexual activity when under the influence of drugs or alcohol",
          "Be extra cautious during travel or in unfamiliar places",
          "Don't engage in sexual activity with someone who seems impaired",
          "Trust your instincts about unsafe situations",
          "Have exit strategies for uncomfortable situations"
        ],
        tips: [
          "Plan ahead for parties and social events",
          "Have a trusted friend you can call for help",
          "Keep emergency contacts easily accessible",
          "Don't go to private locations with people you just met"
        ]
      },
      {
        category: "Warning Signs",
        strategies: [
          "Be aware of signs of STIs in yourself and partners",
          "Watch for unusual discharge, sores, or pain",
          "Monitor for flu-like symptoms after new sexual contact",
          "Pay attention to changes in urination or menstruation",
          "Seek immediate medical attention for concerning symptoms"
        ],
        tips: [
          "Keep a sexual health diary",
          "Take photos of concerning symptoms for doctor visits",
          "Don't ignore persistent symptoms",
          "Get second opinions for serious diagnoses"
        ]
      },
      {
        category: "Emergency Preparedness",
        strategies: [
          "Know where to access emergency contraception",
          "Have contact info for sexual assault resources",
          "Keep first aid supplies for minor injuries",
          "Know your local emergency room locations",
          "Have insurance information readily available"
        ],
        tips: [
          "Program important numbers into your phone",
          "Keep emergency contraception on hand if sexually active",
          "Know the time limits for emergency interventions",
          "Have a plan for getting to medical care quickly"
        ]
      }
    ],
    // Helper function to get random selection
    getRandomSafety: function(category, count = 2) {
      const data = this[`all${category}`];
      if (!data || data.length === 0) return [];
      
      const shuffled = [...data].sort(() => 0.5 - Math.random());
      return shuffled.slice(0, Math.min(count, data.length));
    }
  },

  sexualMythsAndFacts: {
    sizeMyths: [
      {
        myth: "Penis size determines sexual satisfaction",
        fact: "Sexual satisfaction depends much more on technique, communication, and emotional connection than size"
      },
      {
        myth: "Bigger is always better",
        fact: "Many people prefer average-sized partners, and too large can actually cause discomfort"
      }
    ],
    performanceMyths: [
      {
        myth: "Sex should always be spontaneous",
        fact: "Planned sex can be just as exciting and satisfying as spontaneous sex"
      },
      {
        myth: "Good sex should last for hours",
        fact: "Average sexual encounters last 3-7 minutes, and quality matters more than quantity"
      },
      {
        myth: "Men are always ready for sex",
        fact: "People of all genders experience varying levels of sexual desire"
      }
    ],
    bodyMyths: [
      {
        myth: "You need a 'perfect' body for good sex",
        fact: "Sexual satisfaction comes from confidence, communication, and connection, not body appearance"
      },
      {
        myth: "Everyone's body responds the same way",
        fact: "Sexual response varies greatly between individuals - what works for one person may not work for another"
      }
    ]
  },

  advancedTopics: {
    kink: {
      overview: "Kink refers to unconventional sexual practices, concepts, or fantasies that are consensual between adults",
      principles: [
        "Safe, Sane, and Consensual (SSC)",
        "Risk-Aware Consensual Kink (RACK)",
        "Personal Responsibility in Consensual Kink (PRICK)"
      ],
      communication: [
        "Discuss boundaries and limits beforehand",
        "Establish safe words",
        "Negotiate what activities are okay",
        "Plan for aftercare",
        "Regular check-ins about consent"
      ],
      safety: [
        "Start slowly and build experience gradually",
        "Learn proper techniques to avoid injury",
        "Have safety equipment available",
        "Never leave someone in bondage unattended",
        "Respect hard limits absolutely"
      ]
    },
    sexToys: {
      overview: "Sex toys can enhance pleasure for individuals and couples when used safely",
      types: [
        {
          category: "Vibrators",
          description: "Provide vibrating stimulation to various body parts",
          safety: ["Clean before and after use", "Use appropriate lubricant", "Don't share without cleaning"]
        },
        {
          category: "Dildos",
          description: "Designed for penetration",
          safety: ["Use flared base for anal play", "Start small and use lubrication", "Clean thoroughly"]
        },
        {
          category: "Cock Rings",
          description: "Worn around penis/testicles to maintain erection",
          safety: ["Don't wear for more than 30 minutes", "Remove if numbness occurs", "Choose appropriate size"]
        }
      ],
      generalSafety: [
        "Buy from reputable manufacturers",
        "Use body-safe materials (silicone, glass, metal)",
        "Clean toys before and after each use",
        "Use appropriate lubricants",
        "Replace toys when they show wear"
      ]
    }
  },

  lgbtq: {
    overview: "Sexual health information for LGBTQ+ individuals, recognizing diverse identities and needs",
    specificConcerns: [
      {
        population: "Men who have sex with men",
        risks: ["Higher HIV risk", "Anal cancer risk from HPV"],
        prevention: ["PrEP for HIV prevention", "HPV vaccination", "Regular STI testing"]
      },
      {
        population: "Women who have sex with women",
        risks: ["HPV transmission", "Bacterial vaginosis"],
        prevention: ["HPV vaccination", "Barrier methods for oral sex", "Regular gynecological care"]
      },
      {
        population: "Transgender individuals",
        considerations: ["Hormone therapy effects", "Surgery considerations", "Mental health support"],
        care: ["Find affirming healthcare providers", "Understand interaction between hormones and other medications"]
      }
    ]
  },

  mentalHealth: {
    connection: "Sexual health and mental health are closely connected",
    impacts: [
      "Depression and anxiety can affect sexual desire",
      "Sexual problems can cause stress and relationship issues",
      "Body image affects sexual confidence",
      "Trauma can impact sexual well-being"
    ],
    support: [
      "Professional counseling",
      "Sex therapy",
      "Support groups",
      "Educational resources",
      "Medical treatment when appropriate"
    ]
  },

  resources: {
    medical: [
      "Primary care physician",
      "Gynecologist/Urologist",
      "Sexual health clinics",
      "Planned Parenthood",
      "Student health centers"
    ],
    educational: [
      "American Sexual Health Association",
      "Planned Parenthood educational resources",
      "CDC sexual health information",
      "Bedsider (contraception information)",
      "LGBTQ+ specific resources"
    ],
    emergency: [
      "Sexual assault hotline: 112",
    ]
  },

  ageSpecificInfo: {
    teens: {
      focus: ["Body changes during puberty", "First relationships", "Peer pressure", "Identity development"],
      resources: ["School counselors", "Teen health clinics", "Parent/guardian communication", "Peer education programs"]
    },
    youngAdults: {
      focus: ["College health services", "First serious relationships", "Career and relationship balance", "Family planning decisions"],
      resources: ["Campus health centers", "Student counseling services", "Online resources", "Healthcare providers"]
    },
    adults: {
      focus: ["Long-term relationships", "Family planning", "Sexual health maintenance", "Life transitions"],
      resources: ["Healthcare providers", "Relationship counselors", "Sexual health specialists", "Support groups"]
    }
  },

  sexualAnatomyDetailed: {
    maleAnatomyAdvanced: {
      penis: {
        structure: "Consists of three cylinders: two corpora cavernosa and one corpus spongiosum",
        function: "Contains erectile tissue that fills with blood during arousal",
        sensitivity: "Glans (head) is most sensitive, frenulum is highly sensitive",
        variations: "Normal size range 4-7 inches when erect, curve variations are normal",
        healthTips: ["Regular washing", "Self-examination for lumps", "Protect during sports", "Seek help for persistent pain"]
      },
      testicles: {
        structure: "Oval-shaped organs housed in the scrotum",
        function: "Produce sperm and testosterone hormone",
        sensitivity: "Very sensitive to pressure and temperature",
        variations: "One usually hangs lower than the other, size differences are normal",
        healthTips: ["Monthly self-exams", "Protect from injury", "Watch for swelling or lumps", "Temperature regulation is important"]
      },
      prostate: {
        structure: "Walnut-sized gland surrounding the urethra",
        function: "Produces prostatic fluid that nourishes sperm",
        sensitivity: "Contains nerve endings, can be source of pleasure",
        variations: "Size increases with age",
        healthTips: ["Regular check-ups after 50", "Healthy diet", "Regular exercise", "Safe anal play practices"]
      }
    },
    femaleAnatomyAdvanced: {
      vulva: {
        structure: "External female genitalia including labia majora, labia minora, clitoris, and vaginal opening",
        function: "Protects internal organs and provides sexual pleasure",
        sensitivity: "Clitoris has 8000 nerve endings, labia are also sensitive",
        variations: "Wide variety in appearance, color, and size - all normal",
        healthTips: ["Gentle washing with water", "Cotton underwear", "Avoid douching", "Regular self-examination"]
      },
      clitoris: {
        structure: "Complex organ with internal and external parts, like an iceberg",
        function: "Solely for sexual pleasure, no other biological function",
        sensitivity: "Most sensitive part of female anatomy",
        variations: "Size and visibility vary greatly between individuals",
        healthTips: ["Gentle stimulation", "Use lubrication if needed", "Communication with partners", "Normal to be very sensitive"]
      },
      vagina: {
        structure: "Muscular canal connecting external genitals to cervix",
        function: "Birth canal, menstrual flow exit, sexual intercourse",
        sensitivity: "First third is most sensitive, deeper areas less so",
        variations: "Length and width vary, can expand during arousal",
        healthTips: ["Self-cleaning organ", "pH balance important", "Regular gynecological care", "Use appropriate lubrication"]
      },
      gSpot: {
        structure: "Area of tissue on the front vaginal wall, part of urethral sponge",
        function: "May contribute to sexual pleasure and different types of orgasm",
        sensitivity: "Responds to pressure and massage-like touch",
        variations: "Not everyone finds G-spot stimulation pleasurable",
        healthTips: ["Gentle exploration", "Communicate with partner", "Use adequate lubrication", "No pressure to find or enjoy"]
      }
    },
    intersexVariations: {
      overview: "Intersex conditions occur when reproductive or sexual anatomy doesn't fit typical male or female patterns",
      conditions: [
        "Androgen insensitivity syndrome",
        "Congenital adrenal hyperplasia", 
        "5-alpha reductase deficiency",
        "Gonadal dysgenesis"
      ],
      support: ["Medical care", "Psychological support", "Intersex support groups", "Advocacy organizations"]
    }
  },

  sexualResponseAdvanced: {
    arousalProcess: {
      psychological: [
        "Mental stimulation and fantasy",
        "Emotional connection and trust",
        "Anticipation and desire",
        "Relaxation and comfort",
        "Absence of distractions"
      ],
      physiological: [
        "Increased blood flow to genitals",
        "Heart rate and breathing increase",
        "Muscle tension builds",
        "Lubrication/erection occurs",
        "Skin becomes more sensitive"
      ]
    },
    orgasmTypes: {
      clitoralOrgasm: {
        description: "Orgasm achieved through clitoral stimulation",
        characteristics: ["Sharp, intense sensation", "Localized pleasure", "Can lead to multiple orgasms"],
        techniques: ["Direct stimulation", "Indirect stimulation", "Vibration", "Oral stimulation"]
      },
      vaginalOrgasm: {
        description: "Orgasm achieved through vaginal stimulation",
        characteristics: ["Deep, spreading sensation", "Full-body feeling", "Often combined with clitoral"],
        techniques: ["G-spot stimulation", "Deep penetration", "Pressure and rhythm", "Combined stimulation"]
      },
      blendedOrgasm: {
        description: "Combination of clitoral and vaginal stimulation",
        characteristics: ["Intense full-body experience", "Multiple sensation types", "Often longer lasting"],
        techniques: ["Simultaneous stimulation", "Alternating techniques", "Partner coordination", "Sex toy assistance"]
      },
      multipleOrgasms: {
        description: "Experiencing several orgasms in one session",
        characteristics: ["Short refractory period", "Building intensity", "Requires relaxation"],
        techniques: ["Continued stimulation", "Breathing techniques", "Relaxation between peaks", "Communication"]
      },
      prostateMassage: {
        description: "Stimulation of the prostate gland",
        characteristics: ["Deep, intense sensation", "Different from penile orgasm", "Can be very powerful"],
        techniques: ["Internal massage", "External pressure", "Proper lubrication", "Gradual approach"]
      }
    },
    sexualDifficulties: {
      arousalChallenges: [
        "Difficulty becoming aroused",
        "Loss of arousal during activity", 
        "Anxiety affecting arousal",
        "Medical conditions impacting response",
        "Medication side effects"
      ],
      solutions: [
        "Extended foreplay",
        "Stress reduction techniques",
        "Medical consultation",
        "Communication with partner",
        "Professional counseling"
      ]
    }
  },

  intimacyTechniques: {
    oralSex: {
      forVulvaOwners: {
        basics: ["Start slowly and gently", "Pay attention to responses", "Use tongue, lips, and breath", "Vary pressure and speed"],
        techniques: [
          "Circular motions around clitoris",
          "Up and down tongue movements",
          "Gentle sucking motions",
          "Alternating between direct and indirect contact",
          "Using fingers in combination"
        ],
        tips: ["Ask for guidance", "Use dental dams for STI protection", "Stay hydrated", "Take breaks as needed"]
      },
      forPenisOwners: {
        basics: ["Start with kissing and licking", "Vary depth and speed", "Use hands in combination", "Pay attention to sensitive areas"],
        techniques: [
          "Focus on the head (glans)",
          "Licking along the shaft",
          "Gentle suction",
          "Hand and mouth coordination",
          "Attention to testicles"
        ],
        tips: ["Communicate about depth", "Use condoms for STI protection", "Breathe through nose", "Establish signals"]
      },
      safety: ["Use barriers for STI protection", "Good oral hygiene", "Avoid brushing teeth immediately before", "Be aware of cuts in mouth"]
    },
    manualStimulation: {
      techniques: [
        "Vary pressure from light to firm",
        "Use different finger motions",
        "Pay attention to rhythm",
        "Incorporate lubrication",
        "Focus on different areas"
      ],
      forVulvaOwners: [
        "Clitoral stimulation with fingertips",
        "Circular motions around clitoris",
        "Internal stimulation with fingers",
        "G-spot massage techniques",
        "Labia massage and gentle pulling"
      ],
      forPenisOwners: [
        "Varying grip pressure",
        "Focus on head sensitivity",
        "Shaft stimulation techniques",
        "Testicle massage",
        "Perineum pressure points"
      ],
      safety: ["Trim fingernails", "Clean hands thoroughly", "Use appropriate lubrication", "Be gentle with sensitive areas"]
    },
    analPlay: {
      preparation: [
        "Thorough cleaning and hygiene",
        "Start very slowly with fingers",
        "Use plenty of high-quality lubricant",
        "Relax and communicate throughout",
        "Never go from anal to vaginal contact"
      ],
      techniques: [
        "External massage first",
        "Gradual insertion with one finger",
        "Lots of lubrication throughout",
        "Slow, gentle movements",
        "Communication and checking in"
      ],
      safety: [
        "Use condoms for STI protection",
        "Different condom for vaginal contact",
        "Stop if there's pain",
        "Regular STI testing important",
        "Use toys with flared bases"
      ],
      tips: ["Relax anal muscles", "Breathe deeply", "Use appropriate lubricant", "Go at receiver's pace"]
    }
  },

  sexualHealthConditions: {
    commonConditions: [
      {
        condition: "Yeast Infections",
        causes: ["Candida overgrowth", "Antibiotic use", "Hormonal changes", "Tight clothing"],
        symptoms: ["Itching", "Thick white discharge", "Burning during urination", "Vaginal irritation"],
        treatment: ["Antifungal medications", "Probiotics", "Lifestyle changes", "Proper hygiene"],
        prevention: ["Cotton underwear", "Avoid douching", "Probiotics", "Limit sugar intake"]
      },
      {
        condition: "Bacterial Vaginosis",
        causes: ["Bacterial imbalance", "Multiple partners", "Douching", "Smoking"],
        symptoms: ["Fishy odor", "Thin gray discharge", "Burning during urination", "Vaginal itching"],
        treatment: ["Antibiotics", "Probiotics", "Lifestyle changes", "Partner treatment sometimes"],
        prevention: ["Safe sex practices", "Avoid douching", "Limit partners", "Good hygiene"]
      },
      {
        condition: "Urinary Tract Infections (UTIs)",
        causes: ["Bacterial infection", "Sexual activity", "Poor hygiene", "Certain contraceptives"],
        symptoms: ["Burning urination", "Frequent urination", "Cloudy urine", "Pelvic pain"],
        treatment: ["Antibiotics", "Increased fluids", "Cranberry juice", "Pain relief"],
        prevention: ["Urinate after sex", "Wipe front to back", "Stay hydrated", "Good hygiene"]
      },
      {
        condition: "Genital Warts",
        causes: ["HPV infection", "Skin-to-skin contact", "Sexual transmission"],
        symptoms: ["Small bumps", "Cauliflower-like growths", "Itching", "Usually painless"],
        treatment: ["Topical medications", "Cryotherapy", "Laser treatment", "Surgical removal"],
        prevention: ["HPV vaccination", "Condom use", "Regular screening", "Limit partners"]
      }
    ],
    whenToSeeDoctor: [
      "Unusual discharge with odor",
      "Persistent itching or burning",
      "Pain during urination or sex",
      "Unusual bumps or sores",
      "Heavy or irregular bleeding",
      "Pelvic pain",
      "Any concerning symptoms"
    ]
  },

  relationshipDynamics: {
    communicationSkills: {
      activeListening: [
        "Give full attention to partner",
        "Avoid interrupting",
        "Ask clarifying questions",
        "Reflect back what you heard",
        "Validate feelings"
      ],
      expressiveSkills: [
        "Use 'I' statements",
        "Be specific about needs",
        "Express appreciation regularly",
        "Share feelings openly",
        "Ask for what you want"
      ],
      difficultConversations: [
        "Choose appropriate time and place",
        "Stay calm and respectful",
        "Focus on specific behaviors",
        "Avoid blame and criticism",
        "Work toward solutions together"
      ]
    },
    conflictResolution: [
      "Take breaks when heated",
      "Focus on the issue, not the person",
      "Look for compromise solutions",
      "Acknowledge different perspectives",
      "Seek counseling if needed"
    ],
    intimacyBuilding: [
      "Regular quality time together",
      "Physical affection outside bedroom",
      "Emotional vulnerability and sharing",
      "Surprise gestures and romance",
      "Shared experiences and adventures"
    ]
  },

  sexualWellnessLifestyle: {
    physicalHealth: {
      exercise: [
        "Kegel exercises for pelvic floor strength",
        "Cardio for blood flow improvement",
        "Strength training for stamina",
        "Yoga for flexibility and stress relief",
        "Core exercises for stability"
      ],
      nutrition: [
        "Foods rich in zinc (oysters, nuts)",
        "Antioxidant-rich fruits and vegetables",
        "Omega-3 fatty acids for circulation",
        "Adequate hydration",
        "Limit alcohol and processed foods"
      ],
      sleep: [
        "7-9 hours of quality sleep",
        "Consistent sleep schedule",
        "Cool, dark sleeping environment",
        "Avoid screens before bed",
        "Manage stress for better sleep"
      ]
    },
    mentalHealth: [
      "Stress management techniques",
      "Mindfulness and meditation",
      "Body image acceptance work",
      "Addressing performance anxiety",
      "Professional counseling when needed"
    ],
    lifestyle: [
      "Limit alcohol consumption",
      "Quit smoking for better circulation",
      "Manage chronic health conditions",
      "Regular medical check-ups",
      "Safe sun exposure for vitamin D"
    ]
  },

  culturalSexuality: {
    diversePerspectives: [
      "Western individualistic approaches",
      "Eastern holistic sexuality concepts",
      "Indigenous sexuality wisdom",
      "Religious and spiritual perspectives",
      "Modern sex-positive movements"
    ],
    culturalConsiderations: [
      "Family and cultural values",
      "Religious beliefs and practices", 
      "Gender role expectations",
      "Communication style differences",
      "Privacy and modesty norms"
    ],
    globalHealth: [
      "Access to sexual health services",
      "Cultural barriers to care",
      "Education and literacy impacts",
      "Economic factors affecting health",
      "Legal and policy considerations"
    ]
  },

  sexualRights: {
    fundamentalRights: [
      "Right to sexual education and information",
      "Right to sexual autonomy and choice",
      "Right to sexual privacy",
      "Right to sexual equality",
      "Right to sexual pleasure",
      "Right to sexual health services"
    ],
    consent: {
      principles: [
        "Freely given without coercion",
        "Revocable at any time",
        "Informed and understanding",
        "Enthusiastic participation",
        "Ongoing throughout activity"
      ],
      barriers: [
        "Power imbalances",
        "Intoxication or impairment",
        "Age or developmental factors",
        "Fear or intimidation",
        "Legal or institutional coercion"
      ]
    },
    advocacy: [
      "Supporting comprehensive sex education",
      "Advocating for healthcare access",
      "Fighting discrimination",
      "Promoting consent education",
      "Supporting survivor services"
    ]
  },

  mythBusters: {
    popularMyths: [
      {
        myth: "Size determines satisfaction",
        reality: "Technique, communication and emotional connection are much more important",
        evidence: "Research shows satisfaction correlates with relationship quality, not physical attributes",
        impact: "This myth creates unnecessary anxiety and unrealistic expectations"
      },
      {
        myth: "Perfect bodies are required for good intimacy",
        reality: "Confidence, communication and connection matter far more than appearance",
        evidence: "Studies show body acceptance leads to better intimate experiences",
        impact: "Body shame reduces pleasure and satisfaction for everyone"
      },
      {
        myth: "Men always want intimacy",
        reality: "All genders experience varying levels of desire that change over time",
        evidence: "Libido is affected by stress, health, hormones and life circumstances",
        impact: "This creates pressure and ignores individual differences"
      },
      {
        myth: "Intimacy should always be spontaneous",
        reality: "Planned intimacy can be just as satisfying and often more fulfilling",
        evidence: "Anticipation and preparation can enhance experiences",
        impact: "Spontaneity pressure can reduce frequency and enjoyment"
      },
      {
        myth: "Everyone climaxes from penetration alone",
        reality: "Most people with vulvas need additional stimulation to climax",
        evidence: "Only 18% of women climax from penetration alone",
        impact: "This myth causes feelings of inadequacy and frustration"
      }
    ],
    safetyMyths: [
      {
        myth: "You can't get pregnant during menstruation",
        reality: "Sperm can survive up to 5 days, overlapping with fertile periods",
        riskLevel: "Moderate pregnancy risk"
      },
      {
        myth: "Oral contact can't transmit infections",
        reality: "Many STIs including herpes, HPV, and gonorrhea can transmit orally",
        riskLevel: "High STI risk"
      },
      {
        myth: "Withdrawal method is completely safe",
        reality: "Pre-ejaculatory fluid can contain sperm, only 78% effective",
        riskLevel: "High pregnancy risk"
      }
    ]
  },



  didYouKnow: {
    anatomyFacts: [
      {
        fact: "The clitoris contains 8,000 nerve endings",
        context: "Twice as many as the penis glans",
        significance: "Understanding why gentle, varied touch is often preferred",
        category: "Anatomy"
      },
      {
        fact: "The vagina is self-cleaning",
        context: "Natural pH balance maintains health",
        significance: "Douching is unnecessary and can disrupt natural balance",
        category: "Health"
      },
      {
        fact: "Arousal increases pain tolerance by 40%",
        context: "Natural endorphins are released during arousal",
        significance: "The body has natural mechanisms for comfort during intimacy",
        category: "Physiology"
      },
      {
        fact: "The brain is the most important sex organ",
        context: "Mental state significantly affects physical response",
        significance: "Stress reduction and mental health support intimate wellness",
        category: "Psychology"
      }
    ],
    healthFacts: [
      {
        fact: "Regular intimate activity can boost immune system",
        research: "Studies show increased antibody production",
        benefit: "Better overall health and illness resistance"
      },
      {
        fact: "Climax releases oxytocin and endorphins",
        research: "Natural mood elevators and bonding hormones",
        benefit: "Stress relief and emotional connection"
      },
      {
        fact: "Pelvic floor exercises benefit everyone",
        research: "Stronger muscles improve function and sensation",
        benefit: "Better bladder control and intimate experiences"
      }
    ]
  },

 dailyTips: {
  sexualHealth: [
    {
      tip: "Schedule regular STI screenings",
      benefit: "Early detection enables prompt treatment and prevents complications",
      howTo: "Get tested at least annually, or every 3-6 months if sexually active with multiple partners"
    },
    {
      tip: "Know your contraception options",
      benefit: "Understanding methods helps you make informed choices for your body",
      howTo: "Discuss options with your healthcare provider to find what works best for you"
    },
    {
      tip: "Practice consistent safer sex",
      benefit: "Barrier methods significantly reduce STI transmission risk",
      howTo: "Use condoms correctly every time and check expiration dates"
    },
    {
      tip: "Stay informed about HPV vaccination",
      benefit: "HPV vaccines protect against cancers and genital warts",
      howTo: "Consult your doctor about vaccination eligibility and catch-up schedules"
    },
    {
      tip: "Monitor for unusual symptoms",
      benefit: "Early recognition of changes leads to timely medical care",
      howTo: "Watch for discharge changes, sores, pain, or unusual bleeding and seek care promptly"
    }
  ],
  consent: [
    {
      tip: "Understand enthusiastic consent",
      benefit: "Ensures all sexual activity is wanted and respectful",
      howTo: "Look for clear, ongoing verbal and non-verbal agreement from your partner"
    },
    {
      tip: "Know that consent can be withdrawn",
      benefit: "Everyone has the right to change their mind at any time",
      howTo: "Check in with your partner and respect any hesitation or 'no'"
    },
    {
      tip: "Communicate boundaries clearly",
      benefit: "Clear boundaries create safety and trust in relationships",
      howTo: "Discuss what you're comfortable with before sexual activity begins"
    }
  ],
  awareness: [
    {
      tip: "Learn about common STIs and symptoms",
      benefit: "Knowledge helps you recognize when to seek medical attention",
      howTo: "Research chlamydia, gonorrhea, herpes, HIV, and syphilis symptoms"
    },
    {
      tip: "Understand the window period for testing",
      benefit: "Testing too early may give false negative results",
      howTo: "Wait appropriate times after exposure: HIV (3 months), syphilis (6 weeks), others (2 weeks)"
    },
    {
      tip: "Know your local sexual health resources",
      benefit: "Quick access to care when needed reduces anxiety and health risks",
      howTo: "Save contact info for local clinics, hotlines, and emergency services"
    },
    {
      tip: "Educate yourself about PrEP and PEP",
      benefit: "These medications can prevent HIV transmission",
      howTo: "Ask your healthcare provider if pre- or post-exposure prophylaxis is right for you"
    }
  ]
}
};

